import React, { useMemo } from 'react';
import { useTranslation } from '../../../../../core';
import CompanyFeaturesModal from '../../../CompanyFeaturesModal';
import { CompanyDetailsFooter } from '../CompanyDetailsFooter';
import { CompanyFieldGrid, DetailsSection } from '../CompanyDetailsFields';
import { FIELDS, FIELD_TYPES } from '../../utils/constants';

/**
 * Renders company feature controls and the feature-management action.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {Function} props.getFieldValue
 * @param {boolean} props.hasChanges
 * @param {boolean} props.isUpdatingCompany
 * @param {Function} props.onChangeProperty
 * @param {Function} props.onClose
 * @param {Function} props.onSave
 */
export const FeaturesTab = ({
    companyId,
    getFieldValue,
    hasChanges,
    isUpdatingCompany,
    onChangeProperty,
    onClose,
    onSave
}) => {
    const { t } = useTranslation();
    const featureFields = useMemo(() => [
        {
            fieldName: FIELDS.isCasesModuleActivated,
            label: t('companies.isCasesModuleActivated'),
            type: FIELD_TYPES.switch,
            onChange: onChangeProperty(FIELDS.isCasesModuleActivated)
        },
        {
            fieldName: FIELDS.autoDraftEnabled,
            label: t('companies.autoDraftEnabled'),
            type: FIELD_TYPES.switch,
            onChange: onChangeProperty(FIELDS.autoDraftEnabled)
        }
    ], [onChangeProperty, t]);

    return (
        <div>
            <DetailsSection title={t('companies.details.sections.companyFeatures')}>
                <CompanyFieldGrid fields={featureFields} getFieldValue={getFieldValue} />
            </DetailsSection>
            <CompanyFeaturesModal companyId={companyId} isEmbedded={true} />
            <CompanyDetailsFooter
                hasChanges={hasChanges}
                isUpdatingCompany={isUpdatingCompany}
                onClose={onClose}
                onSave={onSave}
            />
        </div>
    );
};
